import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';
import { ConsoleLogger } from '../utilities/console-logger';

@Injectable()
export class LoggingService {
  appInsights: ApplicationInsights;
  constructor() {
    if (!environment.appInsights.instrumentationKey) {
      return;
    }

    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: false // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) { // option to call manually
    ConsoleLogger.logInfo('Log - Page View: ', {loggingActive: !!this.appInsights, name, url});

    if (!this.appInsights) {
      return;
    }
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    ConsoleLogger.logInfo('Log - Event: ', {loggingActive: !!this.appInsights, name, properties});
    if (!this.appInsights) {
      return;
    }
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    ConsoleLogger.logInfo('Log - Metric: ', {loggingActive: !!this.appInsights, name, average, properties});
    if (!this.appInsights) {
      return;
    }
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    ConsoleLogger.logInfo('Log - Exception: ', { loggingActive: !!this.appInsights, exception, severityLevel});
    if (!this.appInsights) {
      return;
    }
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    ConsoleLogger.logInfo('Log - Trace: ', {loggingActive: !!this.appInsights, message, properties});

    if (!this.appInsights) {
      return;
    }
    this.appInsights.trackTrace({ message: message}, properties);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/logging.service.ts